import axios from 'axios'
// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import moment from 'moment'
import { getSessionToken } from './auth'
import INSIConnector from '../utils/insi'
import 'moment/locale/fr'

export const inviteRequiredExpert = async (userId: string, hcsId: string) => {
    const token = await getSessionToken()
    try {
        await axios.get(`${window._env_.REACT_APP_HDS_HOST}/user/inviteToHcs/${userId}/${hcsId}`, {
            headers: {
                'X-Session-Token': token,
            },
        })
    } catch (error) {
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        const errorCode = error.response.data.error?.code
        let message = "Impossible de mettre à jour l'invitation"
        if (errorCode === 1) message = "L'utilisateur est inconnu"
        else if (errorCode === 2) message = "L'utilisateur est déjà dans votre établissement"
        throw new Error(message)
    }
}

export const emailExists = async (email: string, hcsId: string) => {
    const token = await getSessionToken()
    try {
        const result = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/user/emailExists/${email}/${hcsId}`, {
            headers: {
                'X-Session-Token': token,
            },
        })
        const user = result.data
        if (user.profession) {
            const profession = await ToktokdocLib.Profession.findOne(user.profession)
            user.profession = profession.toJSON().name
        }
        return user
    } catch (error) {
        return false
    }
}

export const sendInviteToRequired = async (userId: string, hcsId: string) => {
    const user = ToktokdocLib.User.instance(userId)
    const invitationObject = await user.getUserInvitation(ToktokdocLib.HealthCareService.instance(hcsId))
    const token = await getSessionToken()

    try {
        await axios.get(`${window._env_.REACT_APP_HDS_HOST}/user/sendInvite/${invitationObject.objectId}`, {
            headers: {
                'X-Session-Token': token,
            },
        })
    } catch (error) {
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        const errorCode = error.response.data.error.code
        let message = "Impossible d'envoyer l'invitation"
        if (errorCode === 1) message = "L'invitation a déjà reçu une réponse"
        else if (errorCode === 2) message = 'Une invitation a déjà été envoyée récemment'
        throw new Error(message)
    }
}

export const checkPendingInsBatch = (hcs: Record<string, any>) => {
    const healthCareService = ToktokdocLib.HealthCareService.instance(hcs.objectId)
    return healthCareService.checkPendingInsBatch()
}

export const runINS = async (hcs: Record<string, any>, setFailedPatients: any) => {
    const user = await ToktokdocLib.Utils.getCurrentUser()
    const healthCareService = ToktokdocLib.HealthCareService.instance(hcs.objectId)
    const havePendingBatches = await healthCareService.checkPendingInsBatch()
    const patients = await healthCareService.getAllPatient()

    if (havePendingBatches) {
        const batch = await healthCareService.getPendingInsBatch()
        try {
            if (new Date() < new Date(batch.dateFinalized.iso)) {
                return {
                    type: 'warning',
                    message:
                        "Le traitement de la vérification par lot n'est pas encore finalisé, veuillez essayer ultérieurement.",
                }
            }

            const res = await INSIConnector.checkBatches(user, batch.batchesId, batch.submitedInsNums)

            if (res && res.some((delayedBatch: any) => delayedBatch.delayed)) {
                const delayedBatch = res.find((item: any) => item.delayed)
                const dateFinalized = moment().add(delayedBatch.delayed, 'seconds')
                batch.delayed(dateFinalized.toDate())

                return {
                    type: 'warning',
                    message: `Le traitement de la vérification par lot n'est pas encore finalisé, veuillez essayer le ${dateFinalized.format(
                        'DD/MM/YYYY',
                    )} à ${dateFinalized.format('HH:mm')}.`,
                }
            }

            if (res.includes(4)) {
                batch.failed()
                return {
                    type: 'error',
                    message: 'La vérification par lot a échoué, veuillez essayer ultérieurement.',
                }
            }

            let success = true
            const insiIdentityStatuses = {}

            const allStatuses = await ToktokdocLib.InsiIdentityStatus.findAll()
            allStatuses.forEach((identity: Record<string, any>) => {
                // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                insiIdentityStatuses[identity.code] = identity
            })

            for (const currentBatch of res) {
                for (const patientResult of currentBatch) {
                    if (success && patientResult.oid === false) success = false
                    const patient = patients.find((p: any) => p.objectId === patientResult.objectId)
                    const currentStatus = (await patient.getCurrentInsiIdentityStatus()).insiIdentityStatus.code
                    let saved = false

                    if (patientResult.oid === false) {
                        if (patient.insOid) {
                            patient.insOid = null
                            await patient.save()
                            saved = true
                        }

                        if (currentStatus === 2) {
                            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            await patient.addInsiIdentityStatus(user.objectId, insiIdentityStatuses[1].objectId)
                            saved = true
                        } else if (currentStatus === 4) {
                            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            await patient.addInsiIdentityStatus(user.objectId, insiIdentityStatuses[3].objectId)
                            saved = true
                        }
                    } else {
                        if (patient.insOid !== patientResult.oid) {
                            patient.insOid = patientResult.oid
                            await patient.save()
                            saved = true
                        }

                        if (currentStatus === 1) {
                            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            await patient.addInsiIdentityStatus(user.objectId, insiIdentityStatuses[2].objectId)
                            saved = true
                        } else if (currentStatus === 3) {
                            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            await patient.addInsiIdentityStatus(user.objectId, insiIdentityStatuses[4].objectId)
                            saved = true
                        }
                    }

                    if (saved) await patient.addPatientActionHistory('update', user.objectId)
                }
            }

            const snackbar = success
                ? {
                      type: 'success',
                      message: 'Vérification effectuée avec succès pour l’ensemble des INS.',
                  }
                : {
                      type: 'error',
                      message: 'La vérification a échoué pour au moins un INS.',
                  }

            await batch.finish()
            return snackbar
        } catch (error) {
            batch.failed()
            throw new Error('La vérification par lot a échoué, veuillez essayer ultérieurement.')
        }
    } else {
        try {
            const { failed, batches } = await INSIConnector.sendBatches(user, patients)
            const batchesId: string[] = []
            const submitedInsNums = {}
            let estimationDelay = 0

            batches.forEach((batch: Record<string, any>) => {
                if (estimationDelay < batch.estimationDelay) estimationDelay = batch.estimationDelay
                batchesId.push(batch.batchId)
                // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                submitedInsNums[batch.batchId] = batch.submitedInsNums
            })

            const dateFinalized = moment().add(estimationDelay, 'seconds')
            await healthCareService.addInsBatch(user.objectId, batchesId, dateFinalized.toDate(), submitedInsNums)

            if (setFailedPatients) setFailedPatients(failed)

            return {
                type: 'success',
                message: `Résultats de la vérification par lot disponible pour intégration le ${dateFinalized.format(
                    'DD/MM/YYYY',
                )} à ${dateFinalized.format('HH:mm')}.`,
            }
        } catch (e) {
            // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
            if (e.message === 'TOO_MANY_PATIENTS') throw new Error('Trop de patients pour créer un lot.')
            // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
            if (e.message === 'TOO_FEW_PATIENTS') throw new Error('Pas assez de patients pour créer un lot.')
            throw new Error('Impossible de créer un lot.')
        }
    }
}
